"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisplayEnrichmentSnapshotEntity = exports.DisplayEnrichmentGeometryEntity = exports.DisplayEnrichmentResolvedAreaEntity = exports.DisplayEnrichmentInputLocationEntity = exports.DISPLAY_ENRICHMENT_SNAPSHOT_TYPES = void 0;
const swagger_1 = require("@nestjs/swagger");
exports.DISPLAY_ENRICHMENT_SNAPSHOT_TYPES = [
    "demographic-profile",
    "audience-intelligence",
    "pedestrian-traffic",
];
class DisplayEnrichmentInputLocationEntity {
    lat;
    lon;
}
exports.DisplayEnrichmentInputLocationEntity = DisplayEnrichmentInputLocationEntity;
__decorate([
    (0, swagger_1.ApiProperty)({ example: 40.4168 }),
    __metadata("design:type", Number)
], DisplayEnrichmentInputLocationEntity.prototype, "lat", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({ example: -3.7038 }),
    __metadata("design:type", Number)
], DisplayEnrichmentInputLocationEntity.prototype, "lon", void 0);
class DisplayEnrichmentResolvedAreaEntity {
    kind;
    code;
    name;
}
exports.DisplayEnrichmentResolvedAreaEntity = DisplayEnrichmentResolvedAreaEntity;
__decorate([
    (0, swagger_1.ApiPropertyOptional)({ example: "municipality" }),
    __metadata("design:type", String)
], DisplayEnrichmentResolvedAreaEntity.prototype, "kind", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({ example: "28079" }),
    __metadata("design:type", String)
], DisplayEnrichmentResolvedAreaEntity.prototype, "code", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({ example: "Madrid" }),
    __metadata("design:type", String)
], DisplayEnrichmentResolvedAreaEntity.prototype, "name", void 0);
class DisplayEnrichmentGeometryEntity {
    type;
    coordinates;
}
exports.DisplayEnrichmentGeometryEntity = DisplayEnrichmentGeometryEntity;
__decorate([
    (0, swagger_1.ApiProperty)({
        example: "Polygon",
        enum: ["Polygon", "MultiPolygon", "LineString", "MultiLineString"],
    }),
    __metadata("design:type", String)
], DisplayEnrichmentGeometryEntity.prototype, "type", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({ type: "array", items: { type: "array" } }),
    __metadata("design:type", Array)
], DisplayEnrichmentGeometryEntity.prototype, "coordinates", void 0);
class DisplayEnrichmentSnapshotEntity {
    /**
     * @deprecated
     */
    _id;
    id;
    type;
    provider;
    source;
    inputLocation;
    resolvedArea;
    geometry;
    rawData;
    normalizedData;
    fetchedAt;
    validUntil;
    sourceYear;
    costInEur;
    createdAt;
    updatedAt;
}
exports.DisplayEnrichmentSnapshotEntity = DisplayEnrichmentSnapshotEntity;
__decorate([
    (0, swagger_1.ApiPropertyOptional)({ deprecated: true }),
    __metadata("design:type", String)
], DisplayEnrichmentSnapshotEntity.prototype, "_id", void 0);
__decorate([
    (0, swagger_1.ApiProperty)(),
    __metadata("design:type", String)
], DisplayEnrichmentSnapshotEntity.prototype, "id", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({ enum: exports.DISPLAY_ENRICHMENT_SNAPSHOT_TYPES }),
    __metadata("design:type", String)
], DisplayEnrichmentSnapshotEntity.prototype, "type", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({ example: "datos-espana" }),
    __metadata("design:type", String)
], DisplayEnrichmentSnapshotEntity.prototype, "provider", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({ example: "/v1/test/demographic-profile" }),
    __metadata("design:type", String)
], DisplayEnrichmentSnapshotEntity.prototype, "source", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({ type: DisplayEnrichmentInputLocationEntity }),
    __metadata("design:type", DisplayEnrichmentInputLocationEntity)
], DisplayEnrichmentSnapshotEntity.prototype, "inputLocation", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({ type: DisplayEnrichmentResolvedAreaEntity }),
    __metadata("design:type", DisplayEnrichmentResolvedAreaEntity)
], DisplayEnrichmentSnapshotEntity.prototype, "resolvedArea", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        type: DisplayEnrichmentGeometryEntity,
        description: "GeoJSON geometry in EPSG:4326 (WGS 84) derived from provider geometry.",
    }),
    __metadata("design:type", DisplayEnrichmentGeometryEntity)
], DisplayEnrichmentSnapshotEntity.prototype, "geometry", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({ type: "object", additionalProperties: true }),
    __metadata("design:type", Object)
], DisplayEnrichmentSnapshotEntity.prototype, "rawData", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({ type: "object", additionalProperties: true }),
    __metadata("design:type", Object)
], DisplayEnrichmentSnapshotEntity.prototype, "normalizedData", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({ example: "2026-04-29T10:00:00.000Z" }),
    __metadata("design:type", String)
], DisplayEnrichmentSnapshotEntity.prototype, "fetchedAt", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({ example: "2026-10-29T10:00:00.000Z" }),
    __metadata("design:type", Object)
], DisplayEnrichmentSnapshotEntity.prototype, "validUntil", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({ example: 2025 }),
    __metadata("design:type", Object)
], DisplayEnrichmentSnapshotEntity.prototype, "sourceYear", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({ example: 0.5 }),
    __metadata("design:type", Number)
], DisplayEnrichmentSnapshotEntity.prototype, "costInEur", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({ example: "2026-04-29T10:00:00.000Z" }),
    __metadata("design:type", String)
], DisplayEnrichmentSnapshotEntity.prototype, "createdAt", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({ example: "2026-04-29T10:00:00.000Z" }),
    __metadata("design:type", String)
], DisplayEnrichmentSnapshotEntity.prototype, "updatedAt", void 0);
